// @flow
import React, { Component } from 'react';
import { Link } from 'react-router-dom';


export default class Menu extends Component {

    render () {
        return (
            <nav>
                <ul
                    className="right">
                    <li>
                        <Link to="/patterns">wzory</Link>
                    </li>

                    <li>
                        <a href="/contact/">kontakt / licencja</a>
                    </li>

                    <li>
                        <Link to="/about/">o mnie</Link>
                    </li>

                    <li>
                        <Link to="/stores/">gdzie kupić</Link>
                    </li>
                </ul>
            </nav>);
    }
}



// WEBPACK FOOTER //
// ./src/components/Menu/Menu.js